import styled from 'styled-components'
import { rem } from 'polished'
import { DrawerBodyContentWrapper, LISTING_DRAWER_MAX_WIDTH_PX } from '../drawerBodyLayout.styles'
import { HOTEL_DRAWER_CONTENT_CONTAINER_NAME } from './constants'

export const ContentWrapper = styled(DrawerBodyContentWrapper)`
  max-width: ${rem(LISTING_DRAWER_MAX_WIDTH_PX)};
  container: ${HOTEL_DRAWER_CONTENT_CONTAINER_NAME} / inline-size;
`
